/* tslint:disable */

declare var Object: any;
export interface SFAppraisalInterface {
  "id"?: number;
}

export class SFAppraisal implements SFAppraisalInterface {
  "id": number;
  constructor(data?: SFAppraisalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAppraisal`.
   */
  public static getModelName() {
    return "SFAppraisal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAppraisal for dynamic purposes.
  **/
  public static factory(data: SFAppraisalInterface): SFAppraisal{
    return new SFAppraisal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAppraisal',
      plural: 'SFAppraisals',
      path: 'SFAppraisals',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAppraisal.ts